<template>
  <AppLayout>
    <v-container grid-list-md fluid pa-0 class="repairs">
      <v-layout justify-center row wrap>
        <v-expansion-panel class="elevation-0 lg9">
          <v-expansion-panel-content v-for="group in comingRepairGroups" :key="group.label">
          <template v-slot:header>
            <span class='panel-header'>
              <v-icon :class="group.classes">handyman</v-icon>
              <span style="padding-left: 1rem;">{{group.label}}</span>
              <v-chip class="end-of" small color="primary" text-color="white">
                {{group.repairs.length}}
              </v-chip>
            </span>
          </template>
          <v-flex>
            <v-list v-if="group.repairs.length > 0" subheader>
              <template v-for="repair in group.repairs">
                <v-list-tile
                  :key="repair.id"
                  class="repair d-flex justify-start"
                  @click="displaySelectedRepair(repair)"
                >
                  <v-list-tile-avatar class="avatar">
                    <v-icon :class="group.classes">handyman</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content class="part1">
                    <v-list-tile-title>
                      {{repair.showStreetAddress}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{repair.showRegion}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-content class="part2">
                    <v-list-tile-title>
                      {{repair.description}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{repair.showStatus}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <div style="display:flex" class="chips-container">
                      <v-chip small :class="group.classes">
                       {{ repair.house.lastRepairTimeStamp }}
                      </v-chip>
                      <v-chip small :class="group.classes">
                       {{ repair.lastDays }}
                      </v-chip>
                    </div>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-flex>
        </v-expansion-panel-content>

      </v-expansion-panel>

      </v-layout>
    </v-container>
    <repairTaskDialog ref="dlg"/>
  </AppLayout>
</template>

<script>
import AppLayout from '@/views/AppLayout'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import repairStatus from '@/helpers/repair_status';
import repairTaskDialog from '@/components/repairs/RepairTaskDialog'

export default {
  name: 'Repairs',
  components: {
    AppLayout,
    repairTaskDialog,
  },
  computed: {
    ...mapGetters({
      repairs: 'Repairs/get',
    }),
    comingRepairs() {
      return this.repairs
    },

    comingRepairGroups() {
      const repairGroup = [{
        status: repairStatus.Closed,
        label: 'Closed',
        classes: 'confirming-rerent',
        repairs: this.comingRepairs.filter(repair => repair.status === repairStatus.Closed)
      }, {
        status: repairStatus.Performed,
        label: 'Performed',
        classes: 'confirming-rerent',
        repairs: this.comingRepairs.filter(repair => repair.status === repairStatus.Performed)
      }, {
        status: repairStatus.Assigned,
        label: 'Assigned',
        classes: 'waiting-list',
        repairs: this.comingRepairs.filter(repair => repair.status === repairStatus.Assigned)
      }, {
        status: repairStatus.Proposed,
        label: 'Proposed',
        classes: 'waiting-list',
        repairs: this.comingRepairs.filter(repair => repair.status === repairStatus.Proposed)
      }];
      console.log('repairGroup', {comingRepairs: this.comingRepairs, repairGroup})
      return repairGroup;
    }
  },
  async mounted() {
    await this.fetchRepairList();
  },
  methods: {
    ...mapActions({
      fetchRepairList: 'Repairs/fetchAll',
      selectRepair: 'Repairs/select',
    }),
    async displaySelectedRepair(repair) {
      this.selectRepair(repair);
      await this.$refs.dlg.open()
    },
  }
}
</script>
<style lang="stylus" scoped>
@import '~vuetify/src/stylus/settings/_colors';

.v-list__tile--selected {
  border-left: 5px solid #2484C6;
  background-color: $grey.lighten-3;
}

.repairs {
  position: relative;

  &__list .v-list {
    max-height: 80vh;
    overflow-y: scroll;

    > div {
      border-bottom: 1px solid $grey.lighten-2;
    }
  }

  &__list--selected {
    position: sticky;
    top: 80px;
    max-height: 690px;
    padding-right: 20px !important;

    .v-list {
      max-height: 600px;
    }
  }
}

.chips-container {
  .checking-out {
    background: orange;
  }
  .confirming-rerent {
    background: lightgreen;
  }
  .reminding-rerent {
    background: lightblue;
  }
}

.avatar, .panel-header {
  .checking-out {
    color: orange;
  }
  .confirming-rerent {
    color: green;
  }
  .reminding-rerent {
    color: blue;
  }
}

.panel-header {
  padding:4px;
  width: 100%;
  display: flex;
}

.end-of {
  margin-left: auto;
}

.v-chip__content {
  width: 100%;
}

.repair:hover {
  background-color : lightgray;
  border-radius: 5px;
}

 .part1 {
   width: 200px;
 }

 .part2 {
   width: 200px;
 }

</style>
